import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 24.004 24.004",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.004 24.004\" id=\"icon-plus\"><defs><style>#icon-plus .a{fill:#999;}</style></defs><g transform=\"translate(0)\"><path class=\"a\" d=\"M87.92,473.239a1.067,1.067,0,0,1-1.067,1.067H64.983a1.067,1.067,0,0,1,0-2.134h21.87A1.067,1.067,0,0,1,87.92,473.239Z\" transform=\"translate(-63.916 -461.237)\" /><path class=\"a\" d=\"M473.235,63.915a1.067,1.067,0,0,1,1.067,1.067v21.87a1.067,1.067,0,1,1-2.134,0V64.982A1.067,1.067,0,0,1,473.235,63.915Z\" transform=\"translate(-461.233 -63.915)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol